module.exports = __webpack_public_path__ + "img/menu-icon-clock.5c519920.svg";